export default "__VITE_ASSET__9szk_dJV__"